import { Component, Input, OnInit } from '@angular/core';
import { LayoutRenderLayoutItem, LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

@Component({
	selector: 'cv-schema-render-dynamic-html',
	templateUrl: './dynamic-html.component.html',
})
export class DynamicHtmlComponent implements OnInit {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	options = new LayoutRenderLayoutItemOptions();

	constructor() {
		//
	}

	ngOnInit(): void {
		this.options = { ...this.options, ...this.layoutNode.options };
	}

}
